import {
  HistoryEntryIcon,
  HistoryEntryMainText,
  HistoryItemProps,
  UserInfoDisplay,
} from "./common";
import { CollapsibleMessage } from "./CollapsibleMessage";
import { getStatusIcon, VerificationStatus } from "../../../utils/getStatus";

export const HistoryItemInformationRequested = ({
  item,
  statusesConfig,
}: HistoryItemProps) => {
  const { details } = item;
  const informationRequest =
    details?.informationRequest ?? details?.informationRequested;
  const statusConfig =
    statusesConfig?.object[VerificationStatus.INFORMATION_REQUESTED];

  return (
    <>
      <HistoryEntryIcon>
        {getStatusIcon(VerificationStatus.INFORMATION_REQUESTED, {
          fill: statusConfig?.color,
          color: statusConfig?.color,
          sx: {
            height: 20,
            width: 20,
          },
        })}
      </HistoryEntryIcon>

      <HistoryEntryMainText>Information Requested</HistoryEntryMainText>

      <UserInfoDisplay item={item} statusesConfig={statusesConfig} />

      {informationRequest?.message && (
        <CollapsibleMessage message={informationRequest.message} />
      )}
    </>
  );
};
